import { createRouter, createWebHistory } from 'vue-router'
import SideMenu from '../layouts/side-menu/Main.vue'
import ErrorPage from '../views/error-page/Main.vue'
import Usuarios from '../views/usuarios.vue'
import Talleres from '../views/talleres.vue'
import Mecanicos from '../views/mecanicos.vue'
import Carteras from '../views/carteras.vue'
import Servicios from '../views/servicios.vue'
import Configuracion from '../views/configuracion.vue'
import debug from '../views/debugzone.vue'
import payments from '../views/pagos.vue'
import gruas from '../views/gruas.vue'
import Login from '../views/login.vue'

const routes = [
  {
    path: '/home',
    component: SideMenu,
    children: [
      {
        path: '/usuarios',
        name: 'Usuarios',
        component: Usuarios
      },
      {
        path: '/mecanicos',
        name: 'Mecanicos',
        component: Mecanicos
      },
      {
        path: '/talleres',
        name: 'Talleres',
        component: Talleres
      },
      {
        path: '/carteras',
        name: 'Carteras',
        component: Carteras
      },
      {
        path: '/configuracion',
        name: 'Configuracion',
        component: Configuracion
      },
      {
        path: '/home',
        name: 'Servicios',
        component: Servicios
      },
      {
        path: '/debugzone',
        name: 'debugzone',
        component: debug
      },
      {
        path: '/payments',
        name: 'payments',
        component: payments
      },
      {
        path: '/gruas',
        name: 'gruas',
        component: gruas
      }
    ]
  },
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/error-page',
    name: 'error-page',
    component: ErrorPage
  },
  {
    path: '/:pathMatch(.*)*',
    component: ErrorPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { left: 0, top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.name != 'Login' && !token) {
    next('/')
  } else {
    next()
  }
})

export default router
